// @flow

export const VERSION =
  typeof process.env.VERSION === 'string' ? process.env.VERSION : '0.0.0';

const [VERSION_MAJOR = '0', VERSION_MINOR = '0'] = VERSION.split('.');
export { VERSION_MAJOR, VERSION_MINOR };
